import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	placeholder: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.filters.project.placeholder',
		defaultMessage: 'Choose projects...',
		description: 'Placeholder text for the search box of filter by project',
	},
});
